/* Old Siller — LP 100-OFF. Comportamento compartilhado pelas secoes lp100-*.
   Config vem de window.LP100 (secao lp100-bar). Sem ela, usa 100-OFF / R$500 / R$100.
   Ancoras: um link "#chave" rola ate o elemento com esse id ou, se nao existir, ate a secao
   cujo id termina em "__chave" (ex.: #section_z7j3nc encontra a secao nativa de categorias).
   Rolagem via window.scrollTo: scrollIntoView suave nao move a janela neste tema. */
(function(){
  if(window.__lp100)return;window.__lp100=true;
  function cfg(){var c=window.LP100||{};return {code:(c.code!=null?c.code:'100-OFF'),th:+c.th||50000,off:+c.off||10000,note:(c.note!=null?c.note:'C\u00f3digo 100-OFF')};}
  function fmt(c){return 'R$\u00a0'+(c/100).toLocaleString('pt-BR',{minimumFractionDigits:c%100?2:0,maximumFractionDigits:2});}
  function push(e,d){try{window.dataLayer=window.dataLayer||[];d=d||{};d.event=e;window.dataLayer.push(d);}catch(x){}}
  function findAnchor(key){if(!key)return null;var t=document.getElementById(key);if(t)return t;try{return document.querySelector('[id$="__'+(window.CSS&&CSS.escape?CSS.escape(key):key)+'"]');}catch(x){return null;}}
  function scrollToEl(el,smooth){var y=el.getBoundingClientRect().top+(window.pageYOffset||document.documentElement.scrollTop);window.scrollTo({top:Math.max(0,y),behavior:smooth?'smooth':'auto'});}
  var applied=false;

  function applyCode(){
    var C=cfg();
    if(!C.code)return;
    fetch('/discount/'+encodeURIComponent(C.code)+'?redirect=%2Fcart.js',{credentials:'same-origin'})
      .then(function(){applied=true;paintChips();}).catch(function(){});
  }
  function paintChips(scope){
    var C=cfg();
    (scope||document).querySelectorAll('[data-copy]').forEach(function(b){
      var v=b.querySelector('[data-code-val]'),s=b.querySelector('[data-code-st]');
      if(v)v.textContent=C.code;
      if(s&&!b.dataset.busy)s.textContent=applied?'j\u00e1 aplicado \u00b7 toque para copiar':'toque para copiar';
    });
  }

  /* preco: riscado + final quando passa do minimo; abaixo do minimo, so o preco */
  /* preco como na home: preco final primeiro, riscado depois; selo % OFF com o desconto total */
  function paintPrice(priceEl,dealEl,v,prefix){
    var C=cfg();prefix=prefix||'';
    var p=v.p,c=(v.c&&v.c>p)?v.c:0,fin=p,ref=c;
    var code=!!(dealEl&&p>=C.th);
    if(code){fin=p-C.off;ref=c||p;}
    priceEl.innerHTML=prefix+'<b>'+fmt(fin)+'</b>'+(ref>fin?'<s>'+fmt(ref)+'</s>':'');
    if(dealEl)dealEl.textContent=code?C.note:'';
    var card=priceEl.closest('[data-lp-card]'),badge=card&&card.querySelector('[data-sale-badge]');
    if(badge){
      if(ref>fin){badge.textContent=Math.round((ref-fin)*100/ref)+'% OFF';badge.hidden=false;}
      else badge.hidden=true;
    }
  }

  /* barra */
  function paintBar(c,pulse){
    var bar=document.getElementById('lp-bar');if(!bar)return;
    var C=cfg(),t=bar.querySelector('[data-bar-txt]'),f=bar.querySelector('[data-bar-fill]'),b=bar.querySelector('[data-bar-btn]');
    var s=c.items_subtotal_price||0,q=c.item_count||0,co=C.code?'/checkout?discount='+encodeURIComponent(C.code):'/checkout';
    var anchor=bar.dataset.anchor||'#pecas',lbl=bar.dataset.checkout||'Finalizar';
    bar.classList.toggle('is-done',q>0&&s>=C.th);
    f.style.width=Math.min(100,s/C.th*100)+'%';
    if(!q){t.innerHTML='A partir de '+fmt(C.th)+' em pe\u00e7as: '+fmt(C.off)+' OFF e frete gr\u00e1tis.';b.textContent=bar.dataset.empty||'Ver pe\u00e7as';b.href=anchor;}
    else if(s<C.th){t.innerHTML='Faltam <b>'+fmt(C.th-s)+'</b> para '+fmt(C.off)+' OFF e frete gr\u00e1tis \u00b7 <a href="/cart">sacola ('+q+')</a>';b.textContent=lbl;b.href=co;}
    else{t.innerHTML='<b>'+fmt(C.off)+' OFF e frete gr\u00e1tis liberados.</b> Total '+fmt(s-C.off)+' \u00b7 <a href="/cart">sacola ('+q+')</a>';b.textContent=lbl;b.href=co;}
    if(pulse){bar.classList.remove('is-pulse');void bar.offsetWidth;bar.classList.add('is-pulse');}
  }
  function refresh(pulse){return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){paintBar(c,pulse);return c;}).catch(function(){});}

  /* cards */
  function initCard(card){
    if(card.dataset.ready)return;card.dataset.ready='1';
    var data;try{data=JSON.parse(card.querySelector('[data-pj]').textContent);}catch(x){return;}
    var V=data.v||[];if(!V.length)return;
    var priceEl=card.querySelector('[data-price]'),dealEl=card.querySelector('[data-deal]'),btn=card.querySelector('[data-add]'),msg=card.querySelector('[data-msg]'),form=card.querySelector('[data-lp-form]');
    if(!form||!btn){
      var min=V.reduce(function(m,x){return x.p<m.p?x:m;},V[0]);
      if(priceEl)paintPrice(priceEl,dealEl,min,card.dataset.custom?'A partir de ':'');
      return;
    }
    var nOpt=V[0].o.length,inputs=[].slice.call(card.querySelectorAll('[data-opt]'));
    function chosen(){var a=[];for(var i=0;i<nOpt;i++)a[i]='';inputs.forEach(function(el){a[+el.dataset.opt]=el.value||'';});return a;}
    function fits(v,a,skip){for(var i=0;i<nOpt;i++){if(i===skip)continue;if(a[i]&&v.o[i]!==a[i])return false;}return true;}
    function current(){var a=chosen(),full=a.every(Boolean),v=null;for(var k=0;k<V.length;k++){if(fits(V[k],a,-1)){if(!v)v=V[k];if(V[k].a){v=V[k];break;}}}return {v:v,full:full,a:a};}
    function update(){
      var c=current(),v=c.v;
      inputs.forEach(function(el){if(el.tagName!=='SELECT')return;var idx=+el.dataset.opt;
        [].forEach.call(el.options,function(o){if(!o.value)return;var ok=V.some(function(x){return x.o[idx]===o.value&&x.a&&fits(x,c.a,idx);});o.disabled=!ok;o.textContent=o.value+(ok?'':' \u00b7 esgotado');});});
      if(!v){btn.disabled=true;btn.textContent='Esgotado';return;}
      paintPrice(priceEl,dealEl,v);
      if(c.full&&!v.a){btn.disabled=true;btn.textContent='Esgotado';}else{btn.disabled=false;if(!btn.classList.contains('is-ok'))btn.textContent='Adicionar';}
    }
    inputs.forEach(function(el){el.addEventListener('change',function(){var w=el.closest('.lp-sel');if(w)w.classList.remove('is-need');msg.textContent='';update();});});
    form.addEventListener('submit',function(e){
      e.preventDefault();var c=current();
      if(!c.full){var miss=inputs.filter(function(el){return !el.value;})[0];if(miss){var w=miss.closest('.lp-sel');if(w){w.classList.remove('is-need');void w.offsetWidth;w.classList.add('is-need');}miss.focus();}msg.textContent='Escolha o tamanho para adicionar.';return;}
      if(!c.v||!c.v.a)return;
      btn.disabled=true;btn.textContent='Adicionando\u2026';
      fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:c.v.id,quantity:1}]})})
        .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
        .then(function(res){
          if(!res.ok)throw new Error(res.j&&res.j.description||'N\u00e3o deu para adicionar agora.');
          btn.classList.add('is-ok');btn.textContent='Na sacola \u2713';btn.disabled=false;
          push('lp100_add_to_cart',{variant_id:c.v.id,value:c.v.p/100,currency:'BRL',origin:card.closest('[data-lp-recent]')?'recent':'list'});
          refresh(true);
          setTimeout(function(){btn.classList.remove('is-ok');btn.textContent='Adicionar';},2200);
        })
        .catch(function(err){msg.textContent=err.message;btn.disabled=false;btn.textContent='Adicionar';});
    });
    update();
  }
  function initAll(scope){(scope||document).querySelectorAll('[data-lp-card]').forEach(initCard);paintChips(scope);}

  /* vistos recentemente: IDs gravados pelo tema em localStorage.viewedProducts */
  function initRecent(scope){
    (scope||document).querySelectorAll('[data-lp-recent]').forEach(function(box){
      if(box.dataset.loaded)return;box.dataset.loaded='1';
      var ids=[];try{ids=JSON.parse(localStorage.getItem('viewedProducts')||'[]')||[];}catch(x){}
      ids=ids.map(String).filter(Boolean).slice(0,+box.dataset.limit||4);
      if(!ids.length)return;
      var q=ids.map(function(i){return 'id:'+i;}).join(' OR ');
      var url='/search?q='+encodeURIComponent(q)+'&resources%5Btype%5D=product&resources%5Blimit%5D='+ids.length+'&section_id=lp100-recent-results';
      fetch(url,{credentials:'same-origin'}).then(function(r){return r.text();}).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var items=[].slice.call(doc.querySelectorAll('[data-pid]'));
        if(!items.length)return;
        items.sort(function(a,b){return ids.indexOf(a.dataset.pid)-ids.indexOf(b.dataset.pid);});
        var row=box.querySelector('[data-lp-recent-row]');if(!row)return;
        row.innerHTML='';
        items.forEach(function(it){
          var card=it.querySelector('[data-lp-card]');if(!card)return;
          card=document.importNode(card,true);
          if(box.dataset.deal==='0'){var d=card.querySelector('[data-deal]');if(d)d.remove();}
          row.appendChild(card);
        });
        box.hidden=false;
        initAll(box);
        push('lp100_recent_shown',{count:items.length});
      }).catch(function(){});
    });
  }

  function boot(){
    applyCode();initAll(document);initRecent(document);refresh(false);
    document.addEventListener('click',function(e){
      var cp=e.target.closest('[data-copy]');
      if(cp){var C=cfg(),s=cp.querySelector('[data-code-st]');cp.dataset.busy='1';
        var done=function(){if(s)s.textContent='copiado';setTimeout(function(){delete cp.dataset.busy;paintChips();},1800);};
        if(navigator.clipboard)navigator.clipboard.writeText(C.code).then(done,done);else done();push('lp100_copy_code');}
      var g=e.target.closest('[data-guide]');
      if(g){var d=document.getElementById('lp-guide');if(d&&d.showModal){e.preventDefault();d.showModal();push('lp100_size_guide');}else{window.open('/pages/tabela-de-medidas-aneis','_blank');}}
      var d2=document.getElementById('lp-guide');
      if(d2&&(e.target.closest('[data-guide-close]')||e.target===d2))d2.close();
      var bb=e.target.closest('[data-bar-btn]');
      if(bb&&bb.getAttribute('href').indexOf('/checkout')>-1)push('lp100_checkout_click');
      var a=e.target.closest('a[href^="#"]');
      if(a){var key=a.getAttribute('href').slice(1),tg=findAnchor(key);
        if(tg){e.preventDefault();scrollToEl(tg,true);try{history.replaceState(null,'','#'+key);}catch(x){}push('lp100_anchor',{target:key});}}
    });
    document.addEventListener('shopify:section:load',function(e){initAll(e.target);initRecent(e.target);refresh(false);});
    if(location.hash){var k0=location.hash.slice(1),t0=findAnchor(k0);if(t0)setTimeout(function(){scrollToEl(t0,false);},60);}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();

/* Contagem regressiva do hero (data-lp-count com data-end em ISO). */
(function(){
  if(window.__lp100count)return;window.__lp100count=true;
  function pad(n){return n<10?'0'+n:''+n;}
  function tick(el){
    var end=Date.parse(el.getAttribute('data-end'));if(isNaN(end))return false;
    var left=Math.max(0,Math.floor((end-Date.now())/1000));
    var d=Math.floor(left/86400),h=Math.floor(left%86400/3600),m=Math.floor(left%3600/60),s=left%60;
    var map={d:pad(d),h:pad(h),m:pad(m),s:pad(s)};
    for(var k in map){var n=el.querySelector('[data-u="'+k+'"]');if(n)n.textContent=map[k];}
    if(left===0){var u=el.querySelector('.lp-count__units'),e=el.querySelector('[data-ended]');if(e&&e.textContent.trim()){if(u)u.hidden=true;e.hidden=false;}return false;}
    return true;
  }
  function init(root){
    (root||document).querySelectorAll('[data-lp-count]').forEach(function(el){
      if(el.__lpt)clearInterval(el.__lpt);
      if(tick(el))el.__lpt=setInterval(function(){if(!tick(el))clearInterval(el.__lpt);},1000);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init();});else init();
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  document.addEventListener('shopify:block:select',function(e){init(e.target.closest('section')||document);});
})();
